module.exports = __webpack_public_path__ + "static/img/left.9d53482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/left.png
// module id = 40jw
// module chunks = 1